<template>
  <!-- Screenshots Section Start -->
  <section id="screenshot" class="screenshot padding-top-bottom">
    <div class="screenshot-decor">
      <div class="screenshot-circle1">
        <img :src='"../assets/images/feature-circle-two.png"' alt="feature-circle-two" />
      </div>
      <div class="screenshot-circle2">
        <img :src='"../assets/images/feature-circle.png"' alt="feature-circle" />
      </div>
      <div class="screenshot-circle3">
        <img :src='"../assets/images/main-banner1.png"' alt="feature-circle-three" />
      </div>
    </div>
    <div class="row">
      <div class="container">
        <div class="screenshot-contain">
          <img class="mobile-light-left" :src='"../assets/images/light.png"' alt="light" />
          <img class="laptop img-fluid" :src='"../assets/images/laptop.png"' alt="screenshot-laptop" />
          <img class="mobile-light-right" :src='"../assets/images/light-right.png"' alt="light-right" />
          <swiper ref="mySwiper" :options="swiperOptions" :class="'swiper screenshot-carousel recalc'">
            <swiper-slide v-for="(item, index) in fotos" :key="index">
              <span class="screen-text">{{ item.text }}</span>
              <div class="screenshot-item">
                <img :src='item.img' class="img-fluid" alt="app" />
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </section>
  <!-- Screenshots Section End -->
</template>
<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "Screenshot",
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
      fotos: [
        { img: require("../assets/images/Screenshots/Tela de Cadastro.png"), text: "Tela de Cadastro de Pessoas" },
        { img: require("../assets/images/Screenshots/Tela de caixa.png"), text: "Tela do Livro Caixa" },
        { img: require("../assets/images/Screenshots/Tela de compra manual.png"), text: "Tela de Nota de Compra Manual" },
        { img: require("../assets/images/Screenshots/Tela de contas a pagar.png"), text: "Tela de Contas a pagar" },
        { img: require("../assets/images/Screenshots/Tela de contas a receber.png"), text: "Tela de Contas a receber" },
        { img: require("../assets/images/Screenshots/Tela de estoque.png"), text: "Tela de Estoque" },
        { img: require("../assets/images/Screenshots/Tela de importar xml.png"), text: "Tela de importação de XML de compra" },
        { img: require("../assets/images/Screenshots/Tela de NFe.png"), text: "Tela de Nota Fiscal Eletrônica" },
        { img: require("../assets/images/Screenshots/Tela de orcamento.png"), text: "Tela de Orçamento" },
        { img: require("../assets/images/Screenshots/Tela de os.png"), text: "Tela de Ordem de Serviço" },
        { img: require("../assets/images/Screenshots/Tela de PDV.png"), text: "Tela de PDV" },
        { img: require("../assets/images/Screenshots/Tela do whats.png"), text: "Tela do envio de Whatsapp" },
      ],
      swiperOptions: {
        slidesPerView: 3,
        loop: true,
        spaceBetween: 350,
        zoom: true,
        centeredSlides: true,
        breakpoints: {
          0: { slidesPerView: 1, spaceBetween: 0, },
          500: { slidesPerView: 3, spaceBetween: 10, },
          1000: { slidesPerView: 3, spaceBetween: 50, },
          1200: { slidesPerView: 3, spaceBetween: 250, },
        },
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        }
      },
    };
  },
};
</script>
<style>
.swiper-wrapper {
  align-items: center !important;
}
</style>
<style scoped>
.laptop {
  display: none;
  position: absolute;
  width: 728px;
  margin-top: -40px;
  margin-left: 133px;
}

.screen-text {
  display: none;
  position: absolute;
  top: 80%;
  font-size: 10pt;
  width: 200px;
  color: #444;
  font-weight: 300;
  padding-left: 20px;
  background: linear-gradient(90deg, #18e7d3 0%, rgba(255, 255, 255, 0) 100%);
}

.swiper-slide-active .screen-text {
  display: block;
}

.laptop2 {
  position: absolute;
  left: 50%;
  margin-left: -344px;
  width: 686px;
  margin-top: 8px;
  z-index: 2;
}

.mobile-light-right {
  right: 25% !important;
}

.mobile-light-left {
  left: 25% !important;
}

.swiper-slide-active .img-fluid {
  transition: max-width .1s;
}

@media (min-width: 1200px) {
  .laptop {
    display: block;
  }

  .screen-text {
    top: 75%;
    font-size: 18pt;
    width: 500px;
    color: #ffffff;
  }

  .swiper-slide-active .img-fluid {
    max-width: 600px;
    margin-bottom: 46px;
    border-radius: 5px;
  }

  .swiper-slide-active {
    position: relative;
    left: -222px;
    margin-bottom: 21px;
    z-index: 5;
  }
}

@media (min-width: 1610px) {
  .laptop {
    width: 869px;
    margin-top: -40px;
    margin-left: 247px;
  }

  .swiper-slide-active {
    position: relative;
    left: -215px;
    margin-bottom: 21px;
    z-index: 5;
  }

  .swiper-slide-active .img-fluid {
    max-width: 715px;
    margin-bottom: 46px;
    border-radius: 5px;
  }
}

.swiper-slide-active2 {
  width: 708px !important;
  margin-bottom: 23px;
  border-radius: 10px;
  overflow: hidden;
}

.screenshot-contain {
  margin: 0 50px;
}

.recalc2 {
  margin-left: -200px !important;
  padding-left: 50px !important;
}

.margins {
  margin-left: -366px;
  margin-right: -354px;
}</style>



// WEBPACK FOOTER //
// src/components/screenshots.vue